import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './layout/dialog/alert/alert.component';
import { LoaderComponent } from './layout/dialog/loader/loader.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { StandardPageComponent } from './layout/standard-page/standard-page.component';
import { ApiService } from './services/api.service';
import { CoreService } from './services/core.service';
import { DialogService } from './services/dialog.service';
import { RouterService } from './services/router.service';
import { StorageService } from './services/storage.service';


@NgModule({
  declarations: [HeaderComponent, FooterComponent, StandardPageComponent, AlertComponent, LoaderComponent],
    imports: [
        CommonModule,
        MatGridListModule,
        MatCardModule,
        MatSidenavModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        RouterModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
    ],
  exports: [
    HeaderComponent,
    FooterComponent,
    StandardPageComponent,
    LoaderComponent,
    AlertComponent
  ],
  providers: [
    DialogService,
    MatDialog,
    ApiService,
    RouterService,
    StorageService,
    DialogService,
    CoreService,
  ]
})

export class CoreModule {
}
